<template>
    <div class="ui-content dashboard add-ch-arrow user-section">
        <v-card class="mx-auto normal-card autohg">
            <div class="add-user-form">
                <v-row>
                    <v-col cols="12" sm="2" class="st-blk"></v-col>
                    <v-col cols="12" sm="8" class="st-data">
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-btn @click="openImportModal" class="right-btn cust-btn btn-right" color="primary">
                                    Import Students
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="studentName" label="Student Name" class="required" outlined dense
                                    hide-details></v-text-field>
                                <InputError :data='error.studentName' />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="studentEmail" label="Student Email ID" class="required" outlined
                                    dense hide-details></v-text-field>
                                <InputError :data='error.studentEmail' />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select v-model="selectedCenterId" @change="onCenterSelect" :items="centers"
                                    label="Center" dense hide-details outlined class="required"></v-select>
                                <InputError :data='error.center' />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select v-model="selectedBatch" :items="batches" label="Batch" hide-details dense
                                    outlined class="required"></v-select>
                                <InputError :data='error.batch' />
                            </v-col>
                            <!-- <v-col v-if="onlineUser" cols="12" sm="6">
                                <v-select v-model="selectedTargetExam" :items="examList" label="Target Exam"
                                    hide-details dense outlined class="required"></v-select>
                                <InputError :data='error.exam' />
                            </v-col>
                            <v-col v-if="onlineUser" cols="12" sm="6">
                                <v-select v-model="selectedTargetYear" :items="classes" label="Target Year" hide-details
                                    dense outlined class="required"></v-select>
                                <InputError :data='error.class' />
                            </v-col> -->
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="rollNumber" min="1" label="Roll Number" type="number"
                                    @keydown.space.prevent @keypress="allowedOnlyNumber($event, true)" outlined dense
                                    hide-details></v-text-field>
                                <InputError :data='error.roll_number' />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="password" label="Password"
                                    @keydown.space.prevent outlined dense
                                    hide-details></v-text-field>
                                <InputError :data='error.password' />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="parentName" label="Parent Name" outlined dense
                                    hide-details></v-text-field>
                                <InputError :data='error.parentName' />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="parentEmail" label="Parent Email ID" outlined dense
                                    hide-details></v-text-field>
                                <InputError :data='error.parentEmail' />
                            </v-col>
                            <v-col cols="12" sm="12" class="rg-0">
                                <v-btn @click="onSubmit" :loading="loading" class="right-btn cust-btn"
                                    color="primary">Done</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="2" class="st-blk"></v-col>
                </v-row>
            </div>

        </v-card>


        <v-dialog v-model="importModal" max-width="500">
            <v-card>
                <v-card-title>
                    <span class="text-h6">Import Students</span>

                    
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-file-input v-model="uploadedFile" label="Upload Excel File" accept=".xlsx,.xls" dense
                                outlined placeholder="Select your file" class="my-4" prepend-icon="mdi-file-excel"></v-file-input>
                                <v-tooltip left bottom content-class="cust-new-tooltip-bottom">
                                <template v-slot:activator="{ on }">
                                <v-btn
                                color="primary"
                                @click="downloadTemplate"
                                class="cust-btn"
                                v-on="on"
                                style="width: 100%;"
                                >
                                <v-icon center>mdi-download</v-icon> Download Template
                                </v-btn>
                            </template>
                            <span>Click to download the Excel template</span>
                        </v-tooltip>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="danger" class="cust-btn" @click="closeImportModal" elevation="2">
                        Cancel
                    </v-btn>
                    <v-btn color="primary" class="cust-btn" :disabled="!uploadedFile" @click="uploadFile" elevation="2">
                        Upload
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from '../../../../utils/constants';
export default {
    name: 'AddUsersStudent',
    props: ["tab"],

    data() {
        return {
            loading: false,
            batches: [],
            classes: [],
            centers: [],
            selectedCenterId: null,
            selectedTargetYear: '',
            selectedBatch: null,
            page: 1,
            studentEmail: null,
            studentName: null,
            parentEmail: null,
            parentName: null,
            rollNumber: null,
            password: null,
            error: {
                studentEmail: {
                    type: null,
                    message: null,
                },
                studentName: {
                    type: null,
                    message: null,
                },
                parentEmail: {
                    type: null,
                    message: null,
                },
                parentName: {
                    type: null,
                    message: null,
                },
                batch: {
                    type: null,
                    message: 'Please select batch'
                },
                center: {
                    type: null,
                    message: 'Please select center',
                },
                class: {
                    type: null,
                    message: 'Please select target year'
                },
                exam: {
                    type: null,
                    message: 'Please select target exam'
                },
                roll_number: {
                    type: null,
                    message: "Roll number must be a maximum of 10 digits."
                },
                password: {
                    type: null,
                    message: "Password is optional."
                }
            },
            onlineUser: false,
            selectedTargetExam: '',
            examList: constants.TARGET_EXAM.map((c) => c),
            uploadedFile: null,
            importModal: false,
        }
    },
    methods: {
        ...mapActions({
            me: "userStore/me",
            getCenters: "centerAndBatchStore/getCentersByUser",
            getBatches: "centerAndBatchStore/getBatches",
            getClasses: "userStore/getClasses",
            signUp: "userStore/signUp",
            onImportStudents: "userStore/importStudents",
            onDownloadTemplate: "userStore/downloadStudentTemplate", 
        }),
        onCenterSelect(centerId) {

            this.batches = [];
            this.getBatches({ center_id: [centerId] }).then(response => {
                this.loading = false;
                this.batches = response.list
                    .map(x => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        return c;

                    })

            })
                .catch(err => {
                    this.loading = false;
                });

        },
        requestGetClasses() {
            this.getClasses().then(response => {
                this.loading = false;
                this.classes = response
                    .map(x => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.class_code;
                        return c;

                    })

            })
                .catch(err => {
                    this.loading = false;
                });
        },
        requestGetCenters() {
            this.getCenters().then(response => {
                this.loading = false;
                this.centers = response
                    .map(x => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        return c;

                    })

            })
                .catch(err => {
                    this.loading = false;
                });
        },
        onSubmit() {
            this.loading = true;
            if (this.validate()) {
                let details = null;
                let centerName = this.centers.find((x) => x.value === this.selectedCenterId);
                if (this.parentName && this.parentEmail) {
                    details = {
                        name: this.parentName.trim(),
                        email: this.parentEmail.trim()
                    }
                }
                this.signUp({ 
                    internal: true, 
                    name: this.studentName.trim(), 
                    email: this.studentEmail.trim(), 
                    role_id: this.roleIds.ST, 
                    class: this.selectedTargetYear ? (this.selectedTargetYear).toString() : centerName.text, 
                    batch_id: this.selectedBatch, 
                    details, 
                    target_year: this.selectedTargetYear ? (this.selectedTargetYear).toString() : '', 
                    target_exam: this.selectedTargetExam, 
                    roll_number: this.rollNumber,
                    password: this.password ? this.password : ''
                })
                    .then(response => {
                        this.loading = false;
                        this.studentEmail = '';
                        this.studentName = '';
                        this.parentEmail = '';
                        this.parentName = '';
                        this.selectedTargetYear = '';
                        this.selectedCenterId = null;
                        this.selectedBatch = null;
                        this.selectedTargetExam = '';
                        this.rollNumber = null;
                        this.password = null;
                        this.$toasted.success(`${response.message}`, { icon: 'check_circle', className: 'new-class' });
                        this.me();
                    })
                    .catch(err => {
                        this.loading = false;
                    });
            } else {
                this.loading = false;
            }
        },
        validate() {
            this.studentEmail = this.removeWhiteSpacesFromEmail(this.studentEmail);
            this.parentEmail = this.parentEmail ? this.removeWhiteSpacesFromEmail(this.parentEmail) : null;
            let isValid = true;
            this.error.studentName.type = null;
            this.error.studentEmail.type = null;
            this.error.parentName.type = null;
            this.error.parentEmail.type = null;
            this.error.center.type = null;
            this.error.batch.type = null;
            this.error.class.type = null;
            this.error.exam.type = null;
            this.error.password.type = null;
            if ((!this.studentName) || this.studentName.trim().length < 1) {
                this.error.studentName.type = 'error';
                this.error.studentName.message = 'Please enter student name';
                isValid = false;
            }
            if (this.studentName && this.studentName.trim().length > 70) {
                this.error.studentName.type = 'error';
                this.error.studentName.message = 'Name should not contain more than 70 characters';
                isValid = false;
            }
            if (!this.studentEmail || this.studentEmail.length < 1) {

                this.error.studentEmail.type = 'error';
                this.error.studentEmail.message = 'Please enter student email ID.';
                isValid = false;
            } else if (!this.isValidEmail(this.studentEmail)) {

                this.error.studentEmail.type = 'error';
                this.error.studentEmail.message = 'Please enter a valid email ID.';
                isValid = false;
            }
            if ((!this.selectedCenterId)) {
                this.error.center.type = 'error';
                isValid = false;
            }
            if ((!this.selectedBatch)) {
                this.error.batch.type = 'error';
                isValid = false;
            }
            // if ((!this.selectedTargetYear) && this.onlineUser) {
            //     this.error.class.type = 'error';
            //     isValid = false;
            // }
            // if ((!this.selectedTargetExam) && this.onlineUser) {
            //     this.error.exam.type = 'error';
            //     isValid = false;
            // }
            if ((this.rollNumber) && this.rollNumber.length > 10) {
                this.error.roll_number.type = 'error';
                isValid = false;
            }
            if ((this.parentName && this.parentName.trim().length) || (this.parentEmail && this.parentEmail.trim().length)) {
                if ((!this.parentName) || this.parentName.trim().length < 1) {
                    this.error.parentName.type = 'error';
                    this.error.parentName.message = 'Please enter parent name';
                    isValid = false;
                }
                if (this.parentName && this.parentName.trim().length > 70) {
                    this.error.parentName.type = 'error';
                    this.error.parentName.message = 'Name should not contain more than 70 characters';
                    isValid = false;
                }
                if (!this.parentEmail || this.parentEmail.length < 1) {

                    this.error.parentEmail.type = 'error';
                    this.error.parentEmail.message = 'Please enter parent email ID.';
                    isValid = false;
                } else if (!this.isValidEmail(this.parentEmail)) {

                    this.error.parentEmail.type = 'error';
                    this.error.parentEmail.message = 'Please enter a valid email ID.';
                    isValid = false;
                } else if (this.studentEmail === this.parentEmail) {

                    this.error.parentEmail.type = 'error';
                    this.error.parentEmail.message = 'The email IDs for the student and the parent cannot be the same';
                    isValid = false;
                }
            }
            
            return isValid;
        },
        openImportModal() {
            this.importModal = true;
        },
        closeImportModal() {
            this.importModal = false;
            this.uploadedFile = null;
        },
        async uploadFile() {
            if (!this.uploadedFile) {
                this.$toasted.error("Please upload a file to proceed.");
                return;
            }

            const formData = new FormData();
            formData.append("file", this.uploadedFile);

            this.loading = true;
            this.onImportStudents(formData).then(response => {
                this.loading = false;
                this.$toasted.success(`${response.message}`, { icon: 'check_circle', className: 'new-class' });
                this.closeImportModal();
                this.me();
            })
                .catch(err => {
                    this.loading = false;
                    // this.$toasted.error("Something went wrong. Please try again and upload the file.");
                });
        },
        async downloadTemplate() {
            try {
                const response = await this.onDownloadTemplate();
                
                // Create a Blob from the response
                const url = window.URL.createObjectURL(
                new Blob([response], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
                );
                
                // Create and trigger a download link
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "student_template.xlsx"); // Default file name
                document.body.appendChild(link);
                link.click();

                // Cleanup
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (err) {
                console.error("Error downloading template:", err);
                
                // Handle error (optional: show a message to the user)
                this.$toast.error("Failed to download the template. Please try again.");
            }
        },
    },
    watch: {
        rollNumber() {
            this.error.roll_number.type = null;
        },
        password() {
            this.error.password.type = null;
        },
        selectedCenterId(val) {
            this.error.center.type = null;
        },
        // selectedTargetYear(val) {
        //     this.error.class.type = null;
        // },
        selectedBatch(val) {
            this.error.batch.type = null;
        },
        tab() {
            this.studentEmail = '';
            this.studentName = '';
            this.parentEmail = '';
            this.parentName = ''
            this.selectedTargetYear = '';
            this.selectedCenterId = null;
            this.selectedBatch = null;
            this.selectedTargetExam = '';
            this.batches = [];
            this.rollNumber = '';
            this.password = '';
        },
    },
    mounted() {
        this.onlineUser = this.user.institute === constants.ONLINE_INSTITUTE_ID ? false : true
        this.requestGetCenters();
        this.requestGetClasses();
    },
    computed: {
        ...mapState("userStore", ["user"]),
    }
}
</script>
